import { Filter, Loading2, SearchLoop } from 'assets/icons/index.js';
import axios from 'axios';
import ApiDatabase from 'server';
import Button from 'components/button/index.js';
import Pagination from 'components/pagination/pagination.js';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SubNavbar from '../../../../../components/SubNavbar/SubNavbar.js';
import TableListVivier from './components/table.list.vivier.js';
import StyledInput from '../../../../../components/styledInput/StyledInput';
import MediaQuery from 'react-responsive';
import BottomSheet from '../../../../../components/bottomSheet/BottomSheet';

function ListBodyVivier() {
  const navigate = useNavigate();
  const location = useLocation();
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [departments, setDepartments] = useState([]);
  const [isWaiting, setIsWaiting] = useState(true);
  const [sortName, setSortName] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const limitElement = 25;
  const [totalPages, setTotalPages] = useState(0);
  const [countPerPage, setCountPerPage] = useState(0);
  const [countTotal, setCountTotal] = useState(0);
  const [result, setResult] = useState([]);
  const token = localStorage.getItem('xsrfToken');

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [tempSearch, setTempSearch] = useState('');

  const openFilterSheet = () => { setTempSearch(search); setIsFilterOpen(true); };
  const applyFilters = () => { setSearch(tempSearch); setIsFilterOpen(false); };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
      setCurrentPage(1);
    }, 300);
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    ApiDatabase.getCityDepartments({ token }, (data) => setDepartments(data), () => {});
  }, []);

  useEffect(() => {
    let cancelled = false;
    const controller = new AbortController();

    setIsWaiting(true);
    axios.get(`${process.env.REACT_APP_API_URL}vivier/vivierAllPage`, {
      signal: controller.signal,
      params: { token, page: currentPage, limit: limitElement, search: debouncedSearch, sortName },
    })
      .then(({ data }) => {
        if (cancelled) return;
        setResult(data.viviers || []);
        setCountTotal(data.count || 0);
        setTotalPages(data.countPages || 0);
        setCountPerPage(data.countPerPage || 0);
        setIsWaiting(false);
      })
      .catch((err) => {
        if (!cancelled && err.name !== 'CanceledError') { console.error(err); setIsWaiting(false); }
      });

    return () => { cancelled = true; controller.abort(); };
  }, [token, currentPage, limitElement, debouncedSearch, sortName]);

  const navigateToFicheVivier = (idVivier) => {
    navigate(`../ficheVivier/${idVivier}?searchListVivier=${search}&pageListVivier=${currentPage}`);
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const s = params.get('searchListVivier');
    const p = params.get('pageListVivier');
    if (s) setSearch(s);
    if (p) setCurrentPage(parseInt(p) || 1);
  }, [location.search]);

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <SubNavbar>
        <div className="flex justify-between items-center w-full gap-3">
          <MediaQuery minWidth={768}>
            <div className="flex-1 max-w-[400px]">
              <StyledInput
                type="text"
                placeholder="Rechercher..."
                imgFront={<SearchLoop wh={16} color="#6B7280" />}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </MediaQuery>
          <MediaQuery maxWidth={767}>
            <Button color="SECONDARY" size="SM" onClick={openFilterSheet}>
              <Filter wh={16} color="#374151" />
              <span>Filtrer</span>
            </Button>
          </MediaQuery>
        </div>
      </SubNavbar>

      <div className="flex flex-col w-full h-full overflow-hidden">
        <div className="flex-1 overflow-y-auto">
          {isWaiting ? (
            <div className="flex justify-center items-center h-80">
              <div className="animate-spin"><Loading2 wh={50} color="#FF9600" /></div>
            </div>
          ) : (
            <TableListVivier
              viviers={result}
              setSortName={setSortName}
              sortName={sortName}
              navigateToFicheVivier={navigateToFicheVivier}
              departments={departments}
            />
          )}
        </div>

        {totalPages > 1 && (
          <div className="flex-shrink-0 border-t border-gray-100 bg-white px-4 md:px-8 py-4">
            <Pagination
              currentPage={currentPage}
              countPerPage={countPerPage}
              countTotal={countTotal}
              totalPages={totalPages}
              setCurrentPage={setCurrentPage}
            />
          </div>
        )}
      </div>

      <BottomSheet isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)} title="Filtrer">
        <div className="flex flex-col gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Rechercher</label>
            <StyledInput
              type="text"
              placeholder="Rechercher..."
              imgFront={<SearchLoop wh={16} color="#6B7280" />}
              value={tempSearch}
              onChange={(e) => setTempSearch(e.target.value)}
            />
          </div>
          <Button color="PRIMARY" size="FULL" onClick={applyFilters} className="mt-2">Appliquer</Button>
        </div>
      </BottomSheet>
    </div>
  );
}

export default ListBodyVivier;
